import { Table } from 'react-bootstrap'
import { React  } from '../libraries'

export const TableSchedule = props => {
  return (
    <Table bordered responsive>
      <thead>
        <tr>
          <th>Tanggal</th>
          <th>Uraian</th>
          <th>Media</th>
          <th>Remark</th>
          <th colSpan='2'>PIC</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>12 Juni 2020</td>
          <td>Sosialisasi PPU</td>
          <td>WAG humas,tele forkom,fb nira</td>
          <td>SK pengangkatan,struktur</td>
          <td>Flyer</td>
          <td>Humas</td>
        </tr>
        <tr>
          <td>14 Juni 2020</td>
          <td>Sosialisasi tahapan pemilu</td>
          <td>WAG humas,tele forkom,fb nira</td>
          <td>Rundown pemilu dan munas 2020</td>
          <td>Flyer</td>
          <td>Humas</td>
        </tr>
        <tr>
          <td>16 Juni 2020</td>
          <td>Sosialisasi hak dan kewajiban pemilih</td>
          <td>Wag humas,tele forkom,fb nira</td>
          <td>AD ART,rakornas 2020</td>
          <td>Flyer</td>
          <td>Humas</td>
        </tr>
        <tr>
          <td>18 Juni 2020</td>
          <td>Syarat balon ketum</td>
          <td>WAG humas,tele forkom,fb nira</td>
          <td>AD ART,rakornas 2020</td>
          <td>Flyer</td>
          <td>Humas</td>
        </tr>
        <tr>
          <td>20 Juni 2020</td>
          <td>Sosialisasi tata tertib pemilihan</td>
          <td>WAG humas,tele forkom,fb nira</td>
          <td>Kampanye,pemilu</td>
          <td>Flyer</td>
          <td>Humas</td>
        </tr>
        <tr>
          <td>22 Juni 2020</td>
          <td>Form data dan pemilihan chapter</td>
          <td>WAG humas</td>
          <td>Nama NRA,tlp,email</td>
          <td>Excel</td>
          <td>IT</td>
        </tr>
        <tr>
          <td>28 Juni 2020</td>
          <td>Update data pemilihan chapter</td>
          <td>Email PPU</td>
          <td>Nama NRA,tlp,email</td>
          <td>Excel</td>
          <td>IT</td>
        </tr>
        <tr>
          <td rowSpan='4'>30 Juni 2020</td>
          <td rowSpan='4'>Penyerahan form ke chapter</td>
          <td rowSpan='4'>WAG humas</td>
          <td>Form 01-01 dukungan chapter</td>
          <td rowSpan='4'>Excel</td>
          <td rowSpan='4'>IT</td>
        </tr>
        <tr>
          <td>Form 01-02 bersedia / tidak dukungan</td>
        </tr>
        <tr>
          <td>Form 01-03 Fakta integeritas balon ketum</td>
        </tr>
        <tr>
          <td>Form 01-04 Pendaftaran balon ketum</td>
        </tr>
        <tr>
          <td>1 - 14 Juli 2020</td>
          <td>Penjaringan balon ketum</td>
          <td colSpan='3'>Internal chapter</td>
          <td>Humas C</td>
        </tr>
        <tr>
          <td rowSpan='6'>15 Juli 2020</td>
          <td rowSpan='6'>Penyerahan form dukungan yang sudah di ttd ke PPU</td>
          <td rowSpan='6'>Perwakilan pengchap</td>
          <td>Form dukungan chapter</td>
          <td rowSpan='5'>Asli/ttd</td>
          <td rowSpan='6'>PPU</td>
        </tr>
        <tr>
          <td>Form dukungan chapter</td>
        </tr>
        <tr>
          <td>Berita acara dukungan member</td>
        </tr>
        <tr>
          <td>Form bersedia/tidak dukungan</td>
        </tr>
        <tr>
          <td>Form fakta integeritas caketum</td>
        </tr>
        <tr>
          <td>File kampanye caketum</td>
          <td>File/video</td>
        </tr>
        <tr>
          <td>16 Juli 2020</td>
          <td colSpan='4'>Verifikasi data oleh PPU</td>
          <td>PPU</td>
        </tr>
        <tr>
          <td>17 Juli 2020</td>
          <td>Pengumuman caketum yang lolos</td>
          <td>WAG humas,tele forkom,fb nira</td>
          <td>Hasil pemilu, profile caketum</td>
          <td>Video</td>
          <td>Ketua</td>
        </tr>
        <tr>
          <td>18 Juli 2020</td>
          <td>Sosialisasi kampanye</td>
          <td>Wag humas</td>
          <td colSpan='2'>Tata tertib dan jadwal kampanye</td>
          <td>Humas</td>
        </tr>
        <tr>
          <td>20 Juli / 10 Agt 2020</td>
          <td>Kampanye caketum</td>
          <td>Wag/telegram chapter</td>
          <td colSpan='2'>Invite PPU,balon,timses</td>
          <td>All</td>
        </tr>
        <tr>
          <td>10-16 Agt 2020</td>
          <td>Masa tenang</td>
          <td>Email PPU</td>
          <td colSpan='2'>Email user dan password ke member</td>
          <td>IT</td>
        </tr>
        <tr>
          <td>17 - 20 Agt 2020</td>
          <td>Pemilu</td>
          <td colSpan='3'>www.fevcippu.com</td>
          <td>IT</td>
        </tr>
        <tr>
          <td>29 - 30 Agt 2020</td>
          <td>Pengumuman dan munas pemenang</td>
          <td>Offline-jakarta</td>
          <td colSpan='2'>Serah terima jabatan dll</td>
          <td>All</td>
        </tr>
      </tbody>
    </Table>
  )
}
